import { render, staticRenderFns } from "./vip_product.vue?vue&type=template&id=49421e7b&scoped=true&"
import script from "./vip_product.vue?vue&type=script&lang=js&"
export * from "./vip_product.vue?vue&type=script&lang=js&"
import style0 from "./vip_product.vue?vue&type=style&index=0&id=49421e7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49421e7b",
  null
  
)

export default component.exports